import {
  TextComponent,
  TextComponentProps,
} from '@manifest-cyber/design-system/lib/components/TextComponent';
import { Tooltip, TooltipProps } from '@mantine/core';
import Icon from '../Icon/Icon';

export const TooltipInfoIcon = ({
  withArrow = true,
  size = 'bodySmall',
  ml,
  mr,
  ...props
}: Omit<TooltipProps, 'children'> & { size?: TextComponentProps['variant'] }) => {
  return (
    <Tooltip withArrow={withArrow} {...props}>
      {/* passing ml and mr to Tooltip does not work, so we need to pass it to the TextComponent */}
      <TextComponent ml={ml} mr={mr} variant={size} color="muted">
        <Icon icon="info-circle" iconSharp />
      </TextComponent>
    </Tooltip>
  );
};
